import { Component, Input } from '@angular/core'
import { NavTabGroup } from 'src/app/features/nav-tab-group/nav-tab-group.model'
import { environment } from 'src/environments/environment'
import { AdobeLaunchService } from 'src/server/adobe-launch/adobe-launch.service'

@Component({
  selector: 'compare-button',
  templateUrl: './compare-button.component.html',
  styleUrls: ['./compare-button.component.scss'],
})
export class CompareButtonComponent {
  @Input() fundInput: NavTabGroup
  @Input() size: string
  public compareURL = environment.compareURLPrefix
  finalURL: string

  constructor(public adobeLaunchService: AdobeLaunchService) {}

  compareFunds() {
    this.finalURL = this.compareURL.concat(this.fundInput.ticker)
    window.open(this.finalURL, '_self')
    this.adobeLaunchService.callToAction(
      'Compare',
      `VMF ${this.fundInput.ticker} - ${this.fundInput.fundName} - Dashboard Section - Fund ID ${this.fundInput.fundId}`,
      'Button',
    )
  }
}
